import { Col, Row, Skeleton, Space, Spin, Table } from "antd";
import React, { useEffect, useState } from "react";
import Text from "../../../components/Text/Text";
import CardRewardTour from "../../../components/Card/CardRewardTour";
import icon from "../../../resource/icon";
import TableContainer from "../../../components/Table/TableContainer";
import { FileItem } from "../../OrderManagement/orderComponent/fileItem";
import { image } from "../../../resource";
import Button from "../../../components/Button/Button";
import color from "../../../resource/color";
import { CardStyled, ExpandButton, ImageBox } from "../StyleCSS";
import {
  achievementProduct,
  achievementShop,
  getAchievementById,
} from "../../../datasource/AchievementDataSource";
import { useEffectOnce } from "react-use";
import type {
  AchieveMainReward,
  achieveProdEntity,
  AchieveRewardEntity,
  achieveShopEntity,
  AchieveSpecialReward,
  DetailAchieveEntity,
} from "../../../entities/AchievementEntity";
import { formatDateThai } from "../../../utility/dateHelpers";
import { numberFormatter } from "../../../utility/Formatter";
import PreviewApp from "./PreviewApp";
import StatusBadge from "../../../components/Badge/StatusBadge";
import { MAP_STATUS_TOUR, MAP_STATUS_WORD_TOUR } from "../../../definitions/achievementStatus";

type DetailItem = {
  label: string;
  value: string;
};

const DetailSection = ({
  details,
  loading = false,
}: {
  details: DetailItem[];
  loading: boolean;
}) => {
  const [expanded, setExpanded] = useState(false);

  if (loading) {
    return (
      <div
        style={{
          marginTop: "16px",
        }}
      >
        <Row justify={"start"}>
          <Skeleton.Image
            active
            style={{
              height: "170px",
              width: "178px",
            }}
          />
        </Row>
        <Skeleton
          active
          style={{
            padding: 16,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
          paragraph={{
            rows: 10,
          }}
        />
      </div>
    );
  }

  return (
    <>
      {details.map((item, index) => {
        if (item.label === "img") {
          return (
            <Row key={index} style={{ margin: "14px 0 18px" }}>
              <ImageBox src={item.value} />
            </Row>
          );
        }
        if (item.label === "กติกาและเงื่อนไข") {
          const content = item.value;
          const preview = content.slice(0, 500);
          const showExpand = content.length > 300;

          return (
            <Row key={index} style={{ marginBottom: 12 }}>
              <Col span={5}>
                <Text fontFamily='Sarabun' fontSize={16} color='Text3'>
                  {item.label}
                </Text>
              </Col>
              <Col span={18}>
                <div
                  className='view ql-editor'
                  style={{
                    display: "block",
                    wordBreak: "break-word",
                    wordWrap: "break-word",
                    fontFamily: "Sarabun",
                    fontSize: "16px",
                    padding: 0,
                  }}
                  dangerouslySetInnerHTML={{
                    __html: expanded ? content : preview + (showExpand ? "..." : ""),
                  }}
                />

                {showExpand && (
                  <ExpandButton onClick={() => setExpanded(!expanded)}>
                    <Text color='primary' fontSize={14}>
                      {expanded ? "ย่อข้อความ" : "ดูเพิ่มเติม"}
                    </Text>
                  </ExpandButton>
                )}
              </Col>
            </Row>
          );
        }

        if (item.label === "สถานะ") {
          return (
            <>
              <Row key={index} style={{ marginBottom: 12 }}>
                <Col span={5}>
                  <Text fontFamily='Sarabun' fontSize={16} color='Text3'>
                    {item.label}
                  </Text>
                </Col>
                <Col span={18}>
                  <StatusBadge
                    borderRadius='6px'
                    label={MAP_STATUS_WORD_TOUR[item.value]}
                    bgColor={MAP_STATUS_TOUR[item.value]}
                  />
                </Col>
              </Row>
            </>
          );
        }
        return (
          <Row key={index} style={{ marginBottom: 12 }}>
            <Col span={5}>
              <Text fontFamily='Sarabun' fontSize={16} color='Text3'>
                {item.label}
              </Text>
            </Col>
            <Col span={16}>
              <Text fontFamily='Sarabun' fontSize={16}>
                {item.value}
              </Text>
            </Col>
          </Row>
        );
      })}
    </>
  );
};

const RewardSection = ({
  iconSrc,
  title,
  conditionText,
  data,
  specialReward = false,
  unlockMainRewardNum,
}: {
  iconSrc: string;
  title: string;
  conditionText: string;
  data: AchieveMainReward[] | AchieveSpecialReward[] | undefined;
  specialReward: boolean;
  unlockMainRewardNum?: {
    num: string;
    name: string;
  } | null;
}) => {
  return (
    <>
      <Space wrap size={14} style={{ width: "100%" }} align='center'>
        <img
          src={iconSrc}
          style={{
            display: "block",
            maxHeight: "40px",
            maxWidth: "64px",
            objectFit: "contain",
            marginRight: "12px",
          }}
        />
        <Text fontFamily='Sarabun' fontSize={18} fontWeight={700} color='primary'>
          {title}
        </Text>
      </Space>

      <Space
        wrap
        direction='horizontal'
        size={80}
        style={{ width: "100%", margin: "14px 0px 20px 0px" }}
        align='center'
      >
        <Text fontFamily='Sarabun' fontSize={16} color='Text3'>
          เงื่อนไขการรับรางวัล
        </Text>
        <Text fontFamily='Sarabun' fontSize={16}>
          {conditionText}
        </Text>
      </Space>
      <Row gutter={[16, 16]} justify='start'>
        {data && data.length > 0 ? (
          data.map((item, key) => {
            return (
              <Col key={key} xs={24} sm={12} md={8}>
                <CardRewardTour
                  count={key + 1}
                  specialReward={specialReward}
                  img={item.imageUrl}
                  badgeImg={
                    item.badgeImageUrl ? item.badgeImageUrl : item.badgeMaster?.badgeImageUrl
                  }
                  mileStoneName={specialReward ? item.mileStoneSpecialName : item.mileStoneName}
                  targetAmount={item.targetAmount}
                  rewardName={specialReward ? item.specialRewardName : item.rewardName}
                  unlockMainRewardNum={
                    Array.isArray(unlockMainRewardNum)
                      ? unlockMainRewardNum[key] || null
                      : unlockMainRewardNum || null
                  }
                />
              </Col>
            );
          })
        ) : (
          <div style={{ padding: 42, width: "100%", textAlign: "center" }}>
            <Text fontFamily='Sarabun' color='Disable'>
              ไม่มีระดับการสะสม
            </Text>
          </div>
        )}
      </Row>
    </>
  );
};

const ShopProductSection = ({
  dataShop = [],
  dataProduct = [],
  countShop = 0,
  countProduct = 0,
  onLoadMoreShop,
  onLoadMoreProduct,
  isLoadingShop,
  isLoadingProd,
}: {
  dataShop?: any[];
  dataProduct?: any[];
  countShop?: number;
  countProduct?: number;
  onLoadMoreShop?: () => void;
  onLoadMoreProduct?: () => void;
  isLoadingShop?: boolean;
  isLoadingProd?: boolean;
}) => {
  const shopColumns = [
    {
      title: "รหัสร้านค้า",
      dataIndex: "customerNo",
      key: "customerNo",
      width: "20%",
      render: (value: any, _: any, record: any) => (
        <Text fontFamily='Sarabun' fontSize={14}>
          {value}
        </Text>
      ),
    },
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      width: "60%",
      render: (value: any, _: any, record: any) => (
        <Text fontFamily='Sarabun' fontSize={14}>
          {value}
        </Text>
      ),
    },
    {
      title: "เขตการขาย",
      dataIndex: "customerZone",
      key: "customerZone",
      width: "20%",
      render: (value: any, _: any, record: any) => (
        <Text fontFamily='Sarabun' fontSize={14}>
          {value}
        </Text>
      ),
    },
  ];

  const productColumns = [
    {
      title: "ชื่อสินค้า",
      dataIndex: "productName",
      key: "productName",
      width: "70%",
      render: (value: any, row: any, record: any) => (
        <Space>
          <img
            src={row.imageProduct || image.product_no_image}
            width={50}
            height={50}
            style={{ objectFit: "cover" }}
          />
          <div>
            <Text fontFamily='Sarabun' fontSize={14}>
              {value}
            </Text>
            <br />
            <Text fontFamily='Sarabun' color='Text3' fontSize={12}>
              {row.productGroup}
            </Text>
          </div>
        </Space>
      ),
    },
    {
      title: "Pack Size",
      width: "30%",
      dataIndex: "saleUom",
      key: "saleUom",
      render: (value: any, row: any, record: any) => (
        <div>
          <Text fontFamily='Sarabun' fontSize={14}>
            {value}
          </Text>
          <br />
          <Text fontFamily='Sarabun' color='Text3' fontSize={12}>
            {row.productCode}
          </Text>
        </div>
      ),
    },
  ];

  return (
    <Row gutter={16}>
      <Col span={12}>
        <Row
          justify='space-between'
          align='middle'
          style={{ width: "100%", margin: "0px 0px 20px 0px" }}
        >
          <Row align='middle' gutter={12}>
            <img
              src={icon.shop}
              style={{
                display: "block",
                maxHeight: "40px",
                maxWidth: "64px",
                objectFit: "contain",
              }}
            />
            <Text fontFamily='Sarabun' fontSize={18} fontWeight={700} color='primary'>
              ร้านค้าที่เข้าร่วม
            </Text>
          </Row>
          <Space direction='vertical' align='end'>
            <Text fontFamily='Sarabun' fontSize={12} color='Text3'>
              ประเภทคู่ค้า :<br />
              <Text fontFamily='Sarabun' fontSize={14}>
                {dataShop.map((item) => item.customerType)[0] === "DEALER"
                  ? "Dealer"
                  : "Sub-dealer"}
              </Text>
            </Text>
          </Space>
          <Space direction='vertical' align='end'>
            <Text fontFamily='Sarabun' fontSize={12} color='Text3'>
              จำนวนร้านค้า :<br />
              <Text fontFamily='Sarabun' fontSize={14}>
                {numberFormatter(countShop, 0)} ร้านค้า
              </Text>
            </Text>
          </Space>
        </Row>
        <TableContainer>
          <div
            style={{ height: dataShop.length > 0 ? 400 : "100%", overflowY: "auto" }}
            onScroll={(e) => {
              const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
              if (scrollTop + clientHeight >= scrollHeight - 50) {
                onLoadMoreShop?.();
              }
            }}
          >
            <Table
              loading={isLoadingShop}
              columns={shopColumns}
              dataSource={dataShop}
              rowKey={(record) => record.achievementShopId}
              pagination={false}
              sticky={{ offsetHeader: 0 }}
            />
          </div>
        </TableContainer>
      </Col>

      <Col span={12}>
        <Row
          justify='space-between'
          align='middle'
          style={{ width: "100%", margin: "0px 0px 20px 0px" }}
        >
          <Row align='middle' gutter={12}>
            <img
              src={icon.box}
              style={{
                display: "block",
                maxHeight: "40px",
                maxWidth: "64px",
                objectFit: "contain",
              }}
            />
            <Text fontFamily='Sarabun' fontSize={18} fontWeight={700} color='primary'>
              สินค้าที่เข้าร่วม
            </Text>
          </Row>

          <Space direction='vertical' align='end'>
            <Text fontFamily='Sarabun' fontSize={12} color='Text3'>
              จำนวนสินค้า :<br />
              <Text fontFamily='Sarabun' fontSize={14}>
                {numberFormatter(countProduct, 0)} รายการ
              </Text>
            </Text>
          </Space>
        </Row>
        <TableContainer>
          <div
            style={{ height: dataProduct.length > 0 ? 400 : "100%", overflowY: "auto" }}
            onScroll={(e) => {
              const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
              if (scrollTop + clientHeight >= scrollHeight - 50) {
                onLoadMoreProduct?.();
              }
            }}
          >
            <Table
              loading={isLoadingProd}
              columns={productColumns}
              dataSource={dataProduct}
              rowKey={(record) => record.achievementProductId}
              pagination={false}
              sticky={{ offsetHeader: 0 }}
            />
          </div>
        </TableContainer>
      </Col>
    </Row>
  );
};

function DetailPage({
  achievementId,
  isStep4 = false,
  isApprove = false,
}: {
  achievementId: string;
  isStep4: boolean;
  isApprove?: boolean;
}) {
  const [data, setData] = useState<DetailAchieveEntity>();
  const [shopData, setShopData] = useState<{ count: number; data: achieveShopEntity[] }>();
  const [prodData, setProdData] = useState<{ count: number; data: achieveProdEntity[] }>();
  const [loading, setLoading] = useState(false);
  const [shopPage, setShopPage] = useState(1);
  const [productPage, setProductPage] = useState(1);
  const [loadingShop, setLoadingShop] = useState(false);
  const [loadingProd, setLoadingProd] = useState(false);
  const [achievementReward, setAchievementReward] = useState<AchieveRewardEntity>();
  const [unlockMainRewardNum, setUnlockMainRewardNum] = useState<{ num: string; name: string }>({
    num: "",
    name: "",
  });

  const fetchDetail = async () => {
    setLoading(true);
    try {
      const res = await getAchievementById(achievementId);
      setData(res);
      setAchievementReward(res.achievementReward[0]);
      const mainRewards = res.achievementReward[0].achievementMainReward;
      const specialRewards = res.achievementReward[0].achievementSpecialReward;
      const unlockNum = specialRewards
        .map((special) =>
          mainRewards.find((main) => main.rewardNum === Number(special.unlockMainRewardNum)),
        )
        .filter(Boolean)
        .map((main) => ({ num: main.rewardNum, name: main.rewardName }));

      setUnlockMainRewardNum(unlockNum);
    } catch (error) {
      console.log("err detail achievement", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchShop = async (page: number) => {
    try {
      setLoadingShop(true);
      await new Promise((resolve) => setTimeout(resolve, 800));
      const res = await achievementShop({ page, take: 10, achievementId });
      setShopData((prev) => {
        const newData = res.data.filter(
          (item) => !prev?.data.some((d) => d.achievementShopId === item.achievementShopId),
        );
        return {
          count: res.count,
          data: prev ? [...prev.data, ...newData] : newData,
        };
      });
    } catch (error) {
      console.log("err achievement shop", error);
    } finally {
      setLoadingShop(false);
    }
  };
  const fetchProduct = async (page: number) => {
    try {
      setLoadingProd(true);
      await new Promise((resolve) => setTimeout(resolve, 800));
      const res = await achievementProduct({ page, take: 10, achievementId });
      setProdData((prev) => {
        const newData = res.data.filter(
          (item) => !prev?.data.some((d) => d.achievementProductId === item.achievementProductId),
        );
        return {
          count: res.count,
          data: prev ? [...prev.data, ...newData] : newData,
        };
      });
    } catch (error) {
      console.log("err achievement shop", error);
    } finally {
      setLoadingProd(false);
    }
  };
  const loadMoreShop = () => {
    if (shopData && shopData.data.length >= shopData.count) return;
    const nextPage = shopPage + 1;
    setShopPage(nextPage);
    fetchShop(nextPage);
  };

  const loadMoreProduct = () => {
    if (prodData && prodData.data.length >= prodData.count) return;
    const nextPage = productPage + 1;
    setProductPage(nextPage);
    fetchProduct(nextPage);
  };

  useEffectOnce(() => {
    fetchDetail();
    fetchShop(shopPage);
    fetchProduct(productPage);
  });
  useEffect(() => {
    if (isApprove) {
      fetchDetail();
    }
  }, [isApprove]);
  const details: DetailItem[] = [
    {
      label: "img",
      value: `${data?.imageUrl}`,
    },
    { label: "สถานะ", value: `${data?.thisStatus}` },
    { label: "ชื่อความสำเร็จ", value: `${data?.achievementName}` },
    { label: "รหัสความสำเร็จ", value: `${data?.achievementCode}` },
    { label: "รหัส Ref. Memo", value: `${data?.refMemo}` },
    {
      label: "คำอธิบาย",
      value: `${data?.description || "-"}`,
    },
    {
      label: "ระยะเวลาแคมเปญ",
      value: `${data?.startDate && formatDateThai(new Date(data?.startDate))} น. - ${data?.endDate && formatDateThai(new Date(data?.endDate))} น.`,
    },
    {
      label: "เงื่อนไขความสำเร็จ",
      value: `ยอดซื้อสะสม ${data?.conditionsToAchieve === "THB" ? "(บาท)" : "(จำนวน)"}`,
    },
    {
      label: "เงื่อนไขการรับรางวัล",
      value: `${data?.receiveRewardType === "STEP" ? "รับรางวัลแบบขั้นบันได (รางวัลสูงสุด)" : "รับรางวัลของทุกๆระดับ (ทุกรางวัลที่สำเร็จ)"}`,
    },
    {
      label: "กติกาและเงื่อนไข",
      value: `${data?.rule}`,
    },
  ];
  return (
    <>
      <div style={{ paddingTop: "18px" }}>
        <CardStyled
          type='inner'
          title={
            <Text fontWeight={700} fontSize={18}>
              ข้อมูลทั่วไป
            </Text>
          }
        >
          <Row gutter={[16, 16]} justify='space-between'>
            <Col xs={24} sm={24} md={isStep4 ? 15 : 22} lg={isStep4 ? 16 : 22}>
              <DetailSection details={details} loading={loading} />

              {data?.documentUrl && (
                <Row style={{ marginTop: 28 }}>
                  <Col span={24} md={16}>
                    <Text fontWeight={700}>ไฟล์เอกสารอ้างอิง</Text>
                    <div
                      style={{
                        backgroundColor: color.background1,
                        padding: 16,
                        borderRadius: 4,
                      }}
                    >
                      <FileItem
                        file={{ filePath: data?.documentUrl }}
                        image={
                          <img
                            src={image.pdfIcon}
                            style={{
                              width: 24,
                              height: 30,
                              marginRight: 12,
                            }}
                          />
                        }
                        viewButton={
                          <Button
                            title='ดูรายละเอียด'
                            typeButton='primary'
                            icon={<img src={icon.viewFile} style={{ width: 16, height: 16 }} />}
                            style={{ width: 160 }}
                          />
                        }
                      />
                    </div>
                  </Col>
                </Row>
              )}
            </Col>

            {isStep4 && (
              <Col xs={24} sm={24} md={10} lg={8}>
                <PreviewApp data={data} />
              </Col>
            )}
          </Row>
        </CardStyled>
      </div>

      <div style={{ paddingTop: "120px" }}>
        <CardStyled
          type='inner'
          title={
            <Text fontWeight={700} fontSize={18}>
              รางวัล
            </Text>
          }
        >
          <RewardSection
            iconSrc={icon.airplane}
            title='ระดับการสะสม'
            specialReward={false}
            conditionText={
              data?.receiveRewardType === "STEP"
                ? "รับรางวัลแบบขั้นบันได (รางวัลสูงสุด)"
                : "รับรางวัลของทุกๆระดับ (ทุกรางวัลที่สำเร็จ)"
            }
            data={achievementReward?.achievementMainReward}
          />
          {achievementReward?.isSpecial &&
            achievementReward.achievementSpecialReward?.length > 0 && (
              <div style={{ marginTop: "56px" }}>
                <RewardSection
                  iconSrc={icon.gift}
                  title='รางวัลพิเศษ'
                  specialReward={true}
                  conditionText={
                    data?.receiveRewardType === "STEP"
                      ? "รับรางวัลแบบขั้นบันได (รางวัลสูงสุด)"
                      : "รับรางวัลของทุกๆระดับ (ทุกรางวัลที่สำเร็จ)"
                  }
                  data={achievementReward.achievementSpecialReward}
                  unlockMainRewardNum={
                    Array.isArray(unlockMainRewardNum) && unlockMainRewardNum.length > 0
                      ? unlockMainRewardNum
                      : null
                  }
                />
              </div>
            )}
        </CardStyled>
      </div>

      <div style={{ padding: "18px 0px 20px 0px" }}>
        <CardStyled
          type='inner'
          title={
            <Text fontWeight={700} fontSize={18}>
              ร้านค้า และ สินค้าที่เข้าร่วม
            </Text>
          }
        >
          <ShopProductSection
            dataShop={shopData?.data || []}
            countShop={shopData?.count || 0}
            dataProduct={prodData?.data || []}
            countProduct={prodData?.count || 0}
            onLoadMoreShop={loadMoreShop}
            onLoadMoreProduct={loadMoreProduct}
            isLoadingShop={loadingShop}
            isLoadingProd={loadingProd}
          />
        </CardStyled>
      </div>
    </>
  );
}

export default DetailPage;
